module.exports = __webpack_public_path__ + "img/1e056d64bdd55447785f6c53397b25dc.837c976f.png";